import { Navigate, Outlet } from "react-router-dom";
import { useAppContext } from "../../context/app-context/AppContext";
import { Props } from "./PermissionGuard.Parts";

export const PermissionGuard = ({
  permissions,
  matchAll = false,
  notAllowedRedirect = "/",
  children,
}: Props) => {
  const { user, hasAnyPermission, hasAllPermissions } = useAppContext();

  // If user is not loaded yet, don't render anything (avoid premature redirects)
  if (!user) {
    return null;
  }

  // Check Permissions
  if (matchAll) {
    if (!hasAllPermissions(permissions))
      return <Navigate to={notAllowedRedirect} replace />;
  } else {
    if (!hasAnyPermission(permissions))
      return <Navigate to={notAllowedRedirect} replace />;
  }

  return children || <Outlet />;
};
